import React, { useState } from 'react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const navLinks = [{
    to: '/om-mig',
    label: 'Om Peter'
  }, {
    to: '/omrade-1',
    label: 'Leda utvecklingen'
  }, {
    to: '/omrade-2',
    label: 'Från ett team till tre'
  }, {
    to: '/omrade-3',
    label: 'Hybridarbete'
  }, {
    to: '/faq',
    label: 'Vanliga frågor'
  }];
  return <>
      <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled || mobileOpen ? 'bg-white/90 backdrop-blur-sm shadow-sm' : 'bg-transparent'}`} initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-63">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-64">
          <div className="flex items-center" data-id="element-65">
            <Link to="/" onClick={() => setMobileOpen(false)} data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/goXy5XY5HnKU2PEpdBZ365/Logga-Humble-consulting.png" alt="Humble Consulting" className="h-8" data-id="element-67" />
            </Link>
          </div>

          {/* Desktop nav links */}
          <div className="hidden md:flex items-center gap-6" data-id="element-68">
            <Link to="/om-mig" className="text-sm text-muted hover:text-ink transition-colors" data-id="element-69">
              Om Peter
            </Link>
            <a href="#services" className="text-sm text-muted hover:text-ink transition-colors" data-id="element-70">
              Tjänster
            </a>
            <span className="text-border" data-id="element-71">|</span>
            <Link to="/omrade-1" className="text-sm text-muted hover:text-ink transition-colors" data-id="element-72">
              Leda utvecklingen
            </Link>
            <Link to="/omrade-2" className="text-sm text-muted hover:text-ink transition-colors" data-id="element-73">
              Från ett team till tre
            </Link>
            <Link to="/omrade-3" className="text-sm text-muted hover:text-ink transition-colors" data-id="element-74">
              Hybridarbete
            </Link>
            <span className="text-border" data-id="element-75">|</span>
            <Link to="/faq" className="text-sm text-muted hover:text-ink transition-colors" data-id="element-76">
              Vanliga frågor
            </Link>
          </div>

          <div className="flex items-center gap-3" data-id="element-77">
            <button className="bg-terracotta hover:bg-terracotta/90 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors duration-200 hidden sm:block" onClick={() => window.location.href = 'mailto:peter@humble-consulting.se'} data-id="element-78">
              Boka ett samtal
            </button>

            {/* Mobile hamburger */}
            <button className="md:hidden w-10 h-10 flex items-center justify-center text-ink" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Stäng meny' : 'Öppna meny'} data-id="element-79">
              {mobileOpen ? <X className="w-5 h-5" data-id="element-80" /> : <Menu className="w-5 h-5" data-id="element-81" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile menu overlay */}
      <AnimatePresence data-id="element-82">
        {mobileOpen && <motion.div className="fixed inset-0 z-40 bg-background/98 backdrop-blur-sm pt-20" initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} data-id="element-83">
            <div className="px-8 py-8 flex flex-col gap-1" data-id="element-84">
              {navLinks.map((link, i) => <motion.div key={link.to} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.05,
            duration: 0.25
          }} data-id="element-85">
                  <Link to={link.to} onClick={() => setMobileOpen(false)} className="block py-3 text-lg text-ink hover:text-terracotta transition-colors border-b border-border/30" data-id="element-86">
                    {link.label}
                  </Link>
                </motion.div>)}

              <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: navLinks.length * 0.05,
            duration: 0.25
          }} className="pt-6" data-id="element-87">
                <button className="w-full bg-terracotta hover:bg-terracotta/90 text-white px-8 py-4 rounded-full text-lg font-medium transition-colors" onClick={() => {
              setMobileOpen(false);
              window.location.href = 'mailto:peter@humble-consulting.se';
            }} data-id="element-88">
                  Boka ett samtal
                </button>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}